<b3-modal
  #submitModal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    heading="Confirmação"
    aria-level="2"
    icon="login"
    icon-tone="info"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="project-register-submit-modal__text">
      Você realmente deseja confirmar o envio do projeto de crédito?
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="project-register-submit-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onCancel()">
        Não, cancelar
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConfirm()">
        Sim, confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
